<template>
  <v-container
    id="user-profile"
    tag="section"
  >
    <clients-form
      :create="create"
      :view="view"
      :change="change"
      @create="create_client"
      @close="$router.push('/driver/list')"
    />
  </v-container>
</template>

<script>
  import $ from 'jquery'
  import suggest from 'suggestions-jquery'
  //import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  export default {
    props: ['create', 'change', 'view'],
    data: () => ({

    }),
    computed: {

    },
    watch: {

    },
    methods: {
      create_client: function (data) {
        this.axios.post('/api/clients/create/', data)
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Успешно')
              this.$router.push('/driver/list')
            } else {
              this.$store.commit('snackbar', response.data.error || 'Ошибка при сохранении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
          })
      },
    },
  }
</script>
